import { useQuery } from 'react-query';
import apiFetch from 'react-scale/lib/api-fetch';

export const useFetchCommunityChannels = (searchString: string) => {
  return useQuery([`fetchCommunityChannels`, searchString], () =>
    apiFetch<{
      communityChannels: { _id: string; name: string }[];
    }>(null, `internal/expert-management/community-channels`, {
      method: 'GET',
      query: { searchString },
    }),
  );
};
